import React from 'react'
import { Box, Icon } from '@planningcenter/tapestry-react'
import { PageHeader as T_PageHeader } from '@planningcenter/tapestry'

export function PageHeader(props) {
  if (!props.breadcrumb && !props.subtitle) {
    return <T_PageHeader {...props} />
  }

  const { breadcrumb, subtitle, children, ...rest } = props

  return (
    <T_PageHeader {...rest}>
      <Box>
        {breadcrumb && (
          <Box slot="breadcrumb">
            <Icon name="general.leftChevron" />
            {breadcrumb}
          </Box>
        )}

        {children}

        {subtitle && <Box slot="subtitle">{subtitle}</Box>}
      </Box>
    </T_PageHeader>
  )
}
